import Vue from 'vue';
import {get} from '@/lib/fetcher';

export default {
    namespaced: true,
    state: () => ({
        played: { Phases: {}}
    }),
    mutations: {
        changeDeals(state, newDeals) {
            state.played = newDeals;
        },
        removeDealHand(state, { phase, session, rankset, board }) {
            const deal = state.played.Phases[phase]
                ?.Sessions[session]
                ?.Ranksets[rankset]
                ?.Deals[board];
            if (deal) {
                Vue.set(deal, 'Hand', null);
            }
        },
        removeScore(state, { phase, session, rankset, board, round, series, group, table }) {
            const scores = state.played.Phases[phase]
                ?.Sessions[session]
                ?.Ranksets[rankset]
                ?.Boards[board]
                ?.Scores;
            if (scores) {
                const idx = scores.findIndex(s =>
                    s.Round === round &&
                    s.Series === series &&
                    s.Group === group &&
                    s.Table === table
                );
                if (idx !== -1) scores.splice(idx, 1);
            }
        }
    },
    actions: {
        loadDeals({commit}) {
            get('/api/board/played')
                .then(resp => {
                    commit('changeDeals', resp);
                });
        },
    },
    getters: {
        played: state => state.played,
    }
};
